export default __webpack_public_path__ + "static/ai-f8c6ee8004f301b61f47680c08a57665.svg";